import { fromJS } from 'immutable';

import {
  REQUEST_CLIENTS_TOTAL,
  REQUEST_CLIENTS_TOTAL_SUCCESS,
  REQUEST_CLIENTS_TOTAL_FAILURE,
  CLIENT_ENCODED_DATA_REQUEST,
  CLIENT_ENCODED_DATA_SUCCESS,
  CLIENT_ENCODED_DATA_FAILURE,
} from './types';

export * from './actions';

const initialState = fromJS({
  data: false,
  network: {
    loading: false,
    error: false,
  },
  export: {
    data: [],
    network: {
      loading: false,
      error: false,
    },
  },
});

const clientsTotalReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_CLIENTS_TOTAL:
      return state.setIn(['network', 'loading'], true);
    case REQUEST_CLIENTS_TOTAL_SUCCESS:
      return state.withMutations((s) =>
        s
          .setIn(['network', 'loading'], false)
          .setIn(['network', 'error'], false)
          .set('data', fromJS(action.response)),
      );
    case REQUEST_CLIENTS_TOTAL_FAILURE:
      return state.withMutations((s) =>
        s.setIn(['network', 'loading'], false).setIn(['network', 'error'], action.error),
      );
    case CLIENT_ENCODED_DATA_REQUEST:
      return state.withMutations((s) => s.setIn(['export', 'network', 'loading'], true));
    case CLIENT_ENCODED_DATA_SUCCESS:
      return state.withMutations((s) =>
        s.setIn(['export', 'network', 'loading'], false).setIn(['export', 'data'], action.value),
      );
    case CLIENT_ENCODED_DATA_FAILURE:
      return state.withMutations((s) =>
        s
          .setIn(['export', 'network', 'loading'], false)
          .setIn(['export', 'network', 'error'], true),
      );
    default:
      return state;
  }
};

export default clientsTotalReducer;
